var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#8EDAEA",
    cx: 18,
    cy: 18,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EDAEA",
    fillRule: "nonzero",
    d: "M20.795 25.205l1.41-1.41-5.59-5.59 5.59-5.59-1.41-1.41-5.59 5.59-1.41 1.41 1.41 1.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedChevronLeft);
export default __webpack_public_path__ + "static/media/rounded-chevron-left.08f160fac1605ceb7a164a44e9390816.svg";
export { ForwardRef as ReactComponent };